import axios from '@/assets/http';

export default {
    getCommunityList(params) {
        return axios.get(`/api/v3/frontend/post/suggest`, {params});
    },
    searchCommunityList(params) {
        return axios.get(`/api/v3/frontend/post/search`, {params});
    },
    getInfo(id) {
        return axios.get(`/api/v1/community/post/${id}`,);
    },
    getCommunityTagList(params) {
        return axios.get(`/api/v3/frontend/post/category`, {params});
    },
    getByTag(params) {
        return axios.get(`/api/v3/frontend/post/listByTag`, {params});
    },
    getCommunityByUser(params) {
        return axios.get(`/api/v1/community/posts`, {params});
    },
}
